import React              from 'react';
import { useTranslation } from 'react-i18next';

import RenderButton from '../buttons/base/RenderButton';

function CatalogMoreInfo({ moreInfo }) {
  const { t } = useTranslation();

  if (moreInfo.length === 0) {
    return null;
  }

  return (
    <div className={'moreInfo'}>
      {moreInfo.map((item, i) => (
        <div key={i} className={'moreInfo-item'}>
          <div className={'label'}>{item.label}</div>
          <RenderButton
            type={'link'}
            target={'_blank'}
            className={'fill'}
            uri={item.urlKey}
            label={t('btn_goto')}
          />
        </div>
      ))}
    </div>
  );
}

CatalogMoreInfo.defaultProps = {
  moreInfo: [],
};

export default CatalogMoreInfo;